import type { FC, ReactNode } from "react";
import { Card, CardContent, Stack, Typography } from "@mui/material";

interface DashboardHeaderProps {
  /** Выбранный период и сравнение, formatPeriodCaption. */
  caption: string;
  /** Выбор периода; передаётся снаружи, чтобы виджет его подменял в тестах. */
  picker: ReactNode;
}

/**
 * Шапка дашборда той же панелью, что фильтр на страницах-списках (спека
 * 2026-10-16 §3.1): слева заголовок и строка периода, справа чипы периода.
 * На узком экране чипы уходят под заголовок и переносятся строками.
 */
export const DashboardHeader: FC<DashboardHeaderProps> = ({
  caption,
  picker,
}) => (
  <Card>
    <CardContent>
      <Stack
        direction={{ xs: "column", lg: "row" }}
        spacing={2}
        sx={{
          justifyContent: "space-between",
          alignItems: { xs: "stretch", lg: "center" },
        }}
      >
        <Stack spacing={0.5} sx={{ minWidth: 0 }}>
          <Typography variant="h5" component="h1">
            Панель управления
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {caption}
          </Typography>
        </Stack>
        {picker}
      </Stack>
    </CardContent>
  </Card>
);
